import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config/api";

export const ProjectDetails = () => {

    const { slug } = useParams();

    const [project, setProject] = useState(null);

    useEffect(() => {

        axios
            .get(`${API_URL}/api/projects/${slug}`)
            .then((response) => {

                setProject(response.data);

            })
            .catch((error) => {

                console.log(error);

            });

    }, [slug]);

    if (!project) {
        return (
            <div className="container py-5">
                Loading...
            </div>
        );
    }

    return (

        <>
                    {/* Page Header */}

            <div className="container-fluid page-header py-5">

                <div className="container text-center py-5">

                    <h1 className="display-4 text-white">
                        {project.title}
                    </h1>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center mb-0 animated slideInDown">

                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>

                            <li className="breadcrumb-item">
                                <Link to="/projects">Projects</Link>
                            </li>

                            <li
                                className="breadcrumb-item text-white"
                                aria-current="page"
                            >
                                Project Details
                            </li>

                        </ol>
                    </nav>

                </div>

            </div>
        <div className="container" style={{"padding":"20px", "background":"lightGray", "borderRadius":"8px"}}>

            <h1 className="mb-4">
                {project.title}
            </h1>

            <img
                src={project.featured_image}
                alt={project.title}
                className="img-fluid mb-4 w-100"
                style={{
                    height: "500px",
                    objectFit: "cover",
                    borderRadius: "10px"
                }}
            />

            <div className="text-break"
                dangerouslySetInnerHTML={{
                    __html: project.description
                }}
            />

        </div>
        </>

    );
};